import { NAV_ITEMS } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-background-100 text-foreground-800">
      <div className="mx-auto w-full max-w-7xl px-4 pt-14 pb-10 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="flex items-center gap-2.5" aria-label="本月大瓜首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">本月大瓜</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              聚合本月大瓜爆点与猛料，实时跟进劲爆头条与热门焦点，陪你高效吃瓜、理性围观。
            </p>
          </div>

          <nav aria-label="站点栏目">
            <h3 className="text-sm font-bold text-foreground-950">栏目导航</h3>
            <ul className="mt-4 space-y-2.5">
              {NAV_ITEMS.map((n) => (
                <li key={n.id}>
                  <a href={`#${n.id}`} className="text-sm text-foreground-600 transition hover:text-primary-700">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">内容原则</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li>· 信息以公开可查证为准</li>
              <li>· 未证实内容明确标注</li>
              <li>· 尊重当事人与各方观点</li>
              <li>· 理性吃瓜，对事不对人</li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">联系本站</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-send-line text-primary-600" />
                <a href="mailto:contact@bengyueguo.example" className="hover:text-primary-700">
                  contact@bengyueguo.example
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-refresh-line text-accent-600" /> 热榜实时刷新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-3-line text-secondary-700" /> 焦点热议持续更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-center text-xs leading-relaxed text-foreground-500">
            本站内容为热点信息的整理与展示，均以公开可查证的来源为准，不构成对任何个人或组织的事实判断。部分事件仍在核实中，请以官方回应为准。
          </p>
          <div className="mt-4 flex flex-col items-center justify-between gap-2 text-xs text-foreground-500 sm:flex-row">
            <span>© 2026 本月大瓜 · 保留所有权利</span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line text-primary-600" /> 理性吃瓜 · 不信谣不传谣
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}